import React from 'react';

function Counter() {
  return (
    
    <section class="bd-counter__area counter-space">
    <div class="container">
        <div class="counter__wrapper style-two">
            <div class="counter__shape">
                <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay=".3s"></span>
                <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay=".7s"></span>
                <span class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".7s"></span>
                <span class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s"></span>
            </div>
            <div class="row g-5">
                <div class="col-lg-4 col-md-4">
                    <div class="counter__item">
                        <div class="counter__content">
                            <h2 class="counter__title"><span class="counter">3</span>+</h2>
                            <p>Years of Experience</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4">
                    <div class="counter__item">
                        <div class="counter__content">
                            <h2 class="counter__title"><span class="counter">20</span>+</h2>
                            <p>Projects Completed</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4">
                    <div class="counter__item">
                        <div class="counter__content">
                            <h2 class="counter__title"><span class="counter">7</span>+</h2>
                            <p>Logo Design</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  );
}

export default Counter;
